module.exports = __webpack_public_path__ + "static/media/circle.51e98835.png";